import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
declare var jQuery: any

@Component({
  selector: 'app-animal-diagnosis-table',
  templateUrl: './animal-diagnosis-table.component.html',
  styleUrls: ['./animal-diagnosis-table.component.scss'],
})
export class AnimalDiagnosisTableComponent implements OnInit {
  constructor() {}
  @Input() category
  @Input() pestData
  @Input() diseaseData
  @Input() diseaseDataFilter
  @Input() isLoadingDiagnosis
  @Input() pestDataFilter

  @Output() singleDiagViewData = new EventEmitter<object>()
  @Output() isEditingDiagnosis = new EventEmitter<boolean>()

  searchItem: string
  pPage = 1
  dPage = 1
  count = 10
  isEditing: boolean

  ngOnInit() {}

  setSingleDiagnosisView(data: object): void {
    this.singleDiagViewData.emit(data)
    this.setEditStatus()
  }

  setEditStatus() {
    this.isEditing = true
    this.isEditingDiagnosis.emit(this.isEditing)
  }

  filterDiagnosis(event) {
    this.searchItem = event.target.value
    if (this.category === 'Disease') {
      this.diseaseData
        ? (this.diseaseDataFilter = this.diseaseData.filter(
            (data) =>
              data.name.toLowerCase().indexOf(this.searchItem.toLowerCase()) !==
              -1
          ))
        : null
    } else {
      this.pestData
        ? (this.pestDataFilter = this.pestData.filter(
            (data) =>
              data.name.toLowerCase().indexOf(this.searchItem.toLowerCase()) !==
              -1
          ))
        : null
    }
  }

  checkPublishStatus(status: string, content) {
    return status === content.status
  }
}
